module.exports = __webpack_public_path__ + "media/images/icon/view-142773b7f571d16f758300cd45d3b2d2.svg";